var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: [{
      'customs-tools': _vm.PACKAGE_NAME == 'Customizer'
    }]
  }, [_vm.isConfiguratorLoaded && _vm.isTranslationLoaded ? [_c('preloader'), _vm.regionIsApac ? _c('div', {
    staticClass: "wroot",
    attrs: {
      "id": "master-container"
    }
  }, [_c('section', {
    attrs: {
      "id": "body-container"
    }
  }, [_c('div', {
    staticClass: "configurator main"
  }, [_c('div', {
    staticClass: "masthead header",
    attrs: {
      "id": "masthead",
      "role": "banner"
    }
  }, [_vm.locale === 'zh_cn' ? _c('china-headers') : _vm.locale === 'ko_kr' ? _c('korea-headers') : _vm._e()], 1), _c('buy-panel'), _c('customizer')], 1)])]) : [_c('customizer', {
    class: [{
      'hide-external-headers': !_vm.$store.state.utils.externalHeadersVisible || _vm.noEsiActive || _vm.$store.getters['utils/vsfActive'],
      'hide-external-headers-canvas': _vm.canvasActive
    }]
  }, [_c('buy-panel')], 1)]] : _vm._e()], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }